import { Link, useNavigate } from "react-router";

import { Layout } from "pages/ui/page";
import { useConnectedAccountsQuery } from "shared/api/use-connected-accounts-query";
import { Breadcrumbs } from "shared/ui/breadcrumbs";
import { ProviderTile } from "shared/ui/provider-tile";

import { Account } from "./account";
import headerImageSrc from "./assets/caps.svg";

export const Accounts = () => {
  const navigate = useNavigate();
  const accountsQuery = useConnectedAccountsQuery();
  const data = accountsQuery.data;

  const hasAccounts = Boolean(data && data.connected_accounts.length > 0);

  return (
    <Layout headerImgSrc={headerImageSrc} back="/settings">
      <Breadcrumbs>
        <Breadcrumbs.Item className="text-2xl" as={Link} to="/settings">
          Settings
        </Breadcrumbs.Item>
        <Breadcrumbs.Item className="text-2xl" isActive>
          Accounts
        </Breadcrumbs.Item>
      </Breadcrumbs>

      <div className="mt-5 flex flex-col gap-y-2">
        {data?.connected_accounts.map((account) => {
          return <Account key={account.name} account={account} />;
        })}

        {data && !hasAccounts && (
          <p className="text-pale-grey py-5 text-center text-lg leading-5.5 tracking-[0.4px]">
            No accounts connected yet
          </p>
        )}

        <div className="border-dark-grey flex items-center justify-between rounded-xl border p-3 pl-4">
          <span className="text-lg leading-5.5 tracking-[0.4px] text-white">
            Add Account
          </span>
          <div className="flex gap-x-2">
            <ProviderTile
              provider="apple"
              onClick={() => navigate("/connect/apple")}
            />
            <ProviderTile
              provider="google"
              onClick={() => navigate("/connect/google")}
            />
          </div>
        </div>
      </div>
    </Layout>
  );
};
